import { combineReducers } from 'redux';

import visualitzacio from './visualitzacio';
import meteors from './meteors';
import formulari from './formulari';
import peticioMeteorsEnCurs from './peticioMeteorsEnCurs';

export default combineReducers({
    visualitzacio,
    meteors,
    formulari,
    peticioMeteorsEnCurs
});



// WEBPACK FOOTER //
// ./src/reducers/avis/index.js